import { Component, OnInit, ElementRef } from '@angular/core';
import { AutenticacionService } from './core/services/autenticacion.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ExternoService, PerfilService, NotificacionesService, SplashScreenService } from './core/services';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from './core/services/alert.service';
import { VinculacionDispositivosService } from './core/services/vinculacionDispositivos.service';

/**
 * Componente raíz.
 *
 * @author lreverendo
 * @author dvila
 * @author aarodriguezo
 *
 * @version 01.02.0450
 * @since 01.02.0000
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  public template: string;
  public isUsuarioAutenticado = false;

  constructor(
    private autenticacionService: AutenticacionService,
    private alertService: AlertService,
    private externoService: ExternoService,
    private perfilService: PerfilService,
    private notificacionesService: NotificacionesService,
    private router: Router,
    private translateService: TranslateService,
    private splashScreenService: SplashScreenService,
    private vinculacionDispositivosService: VinculacionDispositivosService,
    private elementRef: ElementRef
  ) {
    this.template = '';
  }

  public ngOnInit(): void {
    this.autenticacionService.configurarInactividad();

    const native = this.elementRef.nativeElement;
    const operacion = native.getAttribute('operacion');

    // Si se cierra la sesión, se redirecciona a la página de login.
    this.autenticacionService.cierreSesionEvent.subscribe((errorSesion: { errorSesion: boolean }) => {
      this.isUsuarioAutenticado = false;
      this.router.navigate(['/login']);
      this.perfilService.detener();
      this.notificacionesService.detener();
      if (errorSesion.errorSesion) {
        this.alertService.lanzarErrorSesion();
      }
    });

    let idiomaSSO = native.getAttribute('idioma');
      if (idiomaSSO != null && idiomaSSO.length > 0) {
        idiomaSSO = idiomaSSO.toLowerCase();
        this.configurarIdiomaSSO(idiomaSSO);
      } 
      let origin = native.getAttribute('origin');
      if (origin != null) {
        origin = origin.toLowerCase();
      }
      else {
        origin = 'web';
      }
      native.removeAttribute('idioma');
      native.removeAttribute('origin');

    if (operacion != null) {
      const data = native.getAttribute('data');
     
      native.removeAttribute('operacion');
      native.removeAttribute('data');

      if (idiomaSSO == null || idiomaSSO.length === 0) {
        idiomaSSO = 'gl';
      }
      this.externo(idiomaSSO, operacion, data);
    } else {
      const code = native.getAttribute('code');
      const state = native.getAttribute('state');
      let error = native.getAttribute('error');
      const system = native.getAttribute('system');
      let bind_result = native.getAttribute('bind_result');

      native.removeAttribute('code');
      native.removeAttribute('state');
      native.removeAttribute('error');
      native.removeAttribute('system');
      native.removeAttribute('bind_result');
      this.configurarIdioma(idiomaSSO);
      this.perfilService.error$.subscribe(this.gestionarError.bind(this));

      this.isUsuarioAutenticado = this.autenticacionService.isUsuarioAutenticado();
      const isPacienteSeleccionado = this.autenticacionService.isPacienteSeleccionado();
      if (this.isUsuarioAutenticado) {
        this.perfilService.cargarPerfilUsuario(this.autenticacionService.getLoginUsuario());
        if (isPacienteSeleccionado) {
          this.perfilService.cargarPerfilPaciente(
            this.autenticacionService.getLoginPaciente(),
            () => this.splashScreenService.cerrarSplashScreen()
          );        }
          else {
          this.splashScreenService.cerrarSplashScreen();
          }

         if (system === 'ABBOTT' || system === 'DEXCOM') {
          if (bind_result === 'error') {
            error = 'error';
            bind_result = null;
          }
          this.vinculacionDispositivosService.setSSOVinculacion(bind_result, error, system);
          this.router.navigate(['/dispositivos']);
        }
      }
      
      
      else {
        this.splashScreenService.cerrarSplashScreen();
        if (system === 'ESAUDE' && code != null && state != null) {
          this.router.navigate(['/login'], {
            queryParams: { code: code, state: state }
          });
        } else if (system === 'ESAUDE' && error != null) {
          this.router.navigate(['/login'], { queryParams: { error: error } });
        } else {
          this.router.navigate(['/login'], {
          queryParams: {} });
        }
      }      
    }
  }

  private externo(idioma: string, operacion: string, data: string) {
    this.configurarIdioma(idioma);
    this.externoService.setOperacion(operacion);
    this.externoService.setData(data);
    this.router.navigate(['/externo']);
  }



  private configurarIdioma(idiomaSSO: string): void {
    let idioma = this.getIdiomaLocalStorage();
    // Si me manda un idioma por SSO, actualizo el actual
    if (idiomaSSO != null && idiomaSSO.length > 0) {
      idioma = idiomaSSO;
    }
    // si no me manda un idioma, cojo el del localStorage y si no existe, pongo por defecto gallego
    else if (idioma === null || idioma.length === 0 || idioma === 'null') {
      idioma = 'gl'; // Idioma por defecto
    }
    this.translateService.setDefaultLang(idioma);
    this.translateService.use(idioma);
    localStorage.setItem('locale', idioma);

  }

  private configurarIdiomaSSO(idiomaSSO: string): void {
    if (idiomaSSO == null || idiomaSSO.length === 0) {
      idiomaSSO = 'gl'; // Idioma por defecto
    }
    localStorage.setItem('idiomaSSO', idiomaSSO);
  }

  private getIdiomaLocalStorage() {
    return localStorage.getItem('locale') || 'gl';
  }

  private gestionarError(error: HttpErrorResponse): void {
    this.alertService.lanzarError(error.status);
  }
}
